const mobileBreakpoint = "(max-width: 600px)";
export default mobileBreakpoint;
